export default __webpack_public_path__ + "static/media/downArrow.ddc37cf2.svg";